import CONST from '../constant'

export default {
	methods: {
		async checkRecaptcha() {
			let result = false
			await this.$request
				.setModeComponent()
				.setOption({
					signedParameters: this.signedParameters,
					componentName: this.componentAction,
					action: CONST.CHECK_CAPTCHA,
					data: {token: this.recaptchaToken}
				})
				.send()
				.then(() => {
					result = true
				}, (error) => {
					result = false
				})

			return result
		},
		async registrationOrAuth() {
			if (this.loading)
				return;

			let isValid = await this.isValidate();
			if (!isValid) {
				return;
			}

			if(this.recaptchaToken) {
				let captchaValid = await this.checkRecaptcha();
				if(!captchaValid) {
					this.resetToken()
					this.loading = false
					this.$dialog.alert("Есть подозрение на автоматическое заполнение формы", {html: true})

					return
				}
			}

			this.loading = true;
			this.error = false;
			this.message = '';

			let ajaxFormData = new FormData(),
				data = {};

			for (let field of this.formFields) {
				data[field.CODE] = field.VALUE;
			}

			for (let key in data) {
				ajaxFormData.append(key, data[key]);
			}

			this.$request
				.setModeComponent()
				.setOption({
					signedParameters: this.signedParameters,
					componentName: this.componentAction,
					action: CONST.REGISTRATION,
					data: ajaxFormData
				})
				.send()
				.then((response) => {
					this.authMode = response.auth_mode;
					this.userId = response.user_id;
					this.confirmStep = true;
					this.loading = false;
				}, (error) => {
					this.loading = false;
					this.confirmStep = false;
					this.$dialog.alert(error, {html: true});
				})
		},
	}
}
